import { Fetch } from '../fetch'

const GTABLE_ENVS = {
  DEV: {
    BASE_URL: 'https://dev-gtable.inface.nexon.com',
    INFO_PATH: 'gid'
  },
  TEST: {
    BASE_URL: 'https://test-gtable.inface.nexon.com',
    INFO_PATH: 'gid'
  },
  LIVE: {
    BASE_URL: 'https://gtable.inface.nexon.com',
    INFO_PATH: 'gid'
  }
}

if (typeof window !== 'undefined') {
  window._inface_common_gtables = []
} else {
  global._inface_common_gtables = []
}

const GTABLE_CONFIGS = typeof window !== 'undefined' ? window._inface_common_gtables : global._inface_common_gtables

async function get(gid, env = 'LIVE') {
  if (!gid || !env) {
    return {}
  }

  const tempEnvTag = (env || '').toUpperCase()
  const env_tag = GTABLE_ENVS[tempEnvTag] ? tempEnvTag : 'LIVE'
  const ENV_INFO = GTABLE_ENVS[env_tag]
  const gtable = GTABLE_CONFIGS.find(gInfo => gInfo._g_env === env_tag && String(gInfo.gid) === String(gid))
  if (gtable) {
    return { ...gtable }
  } else {
    try {
      const gtableFetchUrl = [ENV_INFO.BASE_URL, ENV_INFO.INFO_PATH, `${gid}.json`].join('/')
      const responseStream = await Fetch(gtableFetchUrl)
      const response = await responseStream.json()
      const result = {
        _g_env: env_tag,
        ...response
      }
      GTABLE_CONFIGS.push(result)
      return {...result}
    } catch (e) {
      console.error(e)
      return { _g_env: env_tag }
    }
  }
}

export default {
  get
}
